module.exports = __webpack_public_path__ + "img/stock.b0cfb9e0.svg";